"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "UnauthorizedReason", {
  enumerable: true,
  get: function () {
    return _accountGlobalTypes.UnauthorizedReason;
  }
});
exports.getEmail = exports.authDefault = void 0;
var _accountGlobalTypes = require("../graphql/account/queries/__generated__/accountGlobalTypes");
const getEmail = a => {
  if (a.type === "user") {
    return a.user.email;
  }
  return "";
};
exports.getEmail = getEmail;
const authDefault = exports.authDefault = null;